import gsap from "gsap";
import { initOnScrollAnimation } from "../../../src/js/modules/on-scroll-animations";

let openingAnimation = (popup__overlay, popupBg, popupContent, closeButton) => {
	gsap.fromTo(
		popup__overlay,
		{
			opacity: 0,
		},
		{
			opacity: 1,
			duration: 0.2,
		},
	);

	gsap.fromTo(
		popupBg,
		{
			opacity: 0,
		},
		{
			opacity: 1,
			duration: 0.2,
		},
	);

	gsap.fromTo(
		popupBg,
		{
			scaleX: 0,
		},
		{
			scaleX: 1,
			duration: 0.3,
			ease: "cubic-bezier(0.25, 1, 0.5, 0)",
		},
	);

	gsap.fromTo(
		popupContent,
		{
			opacity: 0,
			x: "0.625rem",
		},
		{
			opacity: 1,
			x: 0,
			delay: 0.2,
		},
	);

	gsap.fromTo(
		closeButton,
		{
			opacity: 0,
			rotate: "90deg",
			x: "0.625rem",
			y: "-0.625rem",
		},
		{
			opacity: 1,
			rotate: 0,
			x: 0,
			y: 0,
			delay: 0.2,
		},
	);
};

let closeAnimation = (popup__overlay, popupBg, popupContent, closeButton) => {
	gsap.fromTo(
		popup__overlay,
		{
			opacity: 1,
		},
		{
			opacity: 0,
			duration: 0.2,
			delay: 0.4,
		},
	);

	gsap.fromTo(
		popupBg,
		{
			opacity: 1,
		},
		{
			opacity: 0,
			duration: 0.2,
			delay: 0.4,
		},
	);

	gsap.fromTo(
		popupBg,
		{
			scaleX: 1,
		},
		{
			scaleX: 0,
			duration: 0.3,
			delay: 0.3,
			ease: "cubic-bezier(0.25, 1, 0.5, 0)",
		},
	);

	gsap.fromTo(
		popupContent,
		{
			opacity: 1,
			x: 0,
		},
		{
			opacity: 0,
			x: "0.625rem",
		},
	);

	gsap.fromTo(
		closeButton,
		{
			opacity: 1,
			rotate: 0,
			x: 0,
			y: 0,
		},
		{
			opacity: 0,
			rotate: "90deg",
			x: "0.625rem",
			y: "-0.625rem",
		},
	);
};

document.querySelectorAll(".js-team").forEach((el) => {
	const cards = el.querySelectorAll(".js-team-card");

	const popup = el.querySelector(".js-team-popup");

	const popup__overlay = el.querySelector(".js-team-popup__overlay");

	const popupBg = el.querySelector(".team-popup__bg");

	const popupContent = el.querySelector(".js-team-popup__content-placement");

	const closeButton = el.querySelector(".js-team-popup__close");

	let isAnimating = false;

	let active_slug = null;

	const popup_content = popup.querySelector(
		".js-team-popup__content-placement",
	);

	const escListener = (e) => {
		if (e.key === "Escape") {
			closePopup();
		}
	};

	const initEscListener = (init) => {
		if (init) {
			document.addEventListener("keydown", escListener);
		} else {
			document.removeEventListener("keydown", escListener);
		}
	};

	[closeButton, popup__overlay].forEach((el) => {
		el.addEventListener("click", () => {
			if (!isAnimating) {
				closePopup();
			}
		});
	});

	const closePopup = () => {
		closeAnimation(popup__overlay, popupBg, popupContent, closeButton);

		isAnimating = true;

		gsap.delayedCall(0.5, () => {
			popup.classList.add("hidden");

			initEscListener(false);

			isAnimating = false;

			window.lenis.start();
			history.replaceState(
				null,
				null,
				window.location.pathname + window.location.search,
			);
		});
	};

	const openPopup = () => {
		popup.classList.remove("hidden");

		initEscListener(true);

		window.lenis.stop();

		isAnimating = true;

		openingAnimation(popup__overlay, popupBg, popupContent, closeButton);

		gsap.delayedCall(0.5, () => {
			isAnimating = false;
		});
	};

	const fillPopupContent = (slug) => {
		active_slug = slug;

		fetch(`/wp-json/wp/v2/team_member?slug=${slug}`)
			.then((res) => res.json())
			.then((post) => {
				const content = post[0].content.raw || post[0].content.rendered;

				popup_content.innerHTML = content;

				openPopup();
			});
	};

	cards.forEach((card) => {
		card.addEventListener("click", () => {
			if (!isAnimating) {
				let slug = card.getAttribute("data-slug");

				window.location.hash = slug;

				if (slug !== active_slug) {
					fillPopupContent(slug);
				} else {
					openPopup();
				}
			}
		});
	});

	// if there's a hash initially

	if (window.location.hash.length > 0) {
		let slug = window.location.hash.split("#").join("");

		fillPopupContent(slug);
	}

	initOnScrollAnimation(el);
});
